import { useState } from 'react';
import { requirementsApi } from '../services/api';

/**
 * Custom hook to handle calculations functionality
 */
const useCalculations = (selectedItemId, setError, setLoading) => {
  // Calculations dialog state
  const [calculationsDialogOpen, setCalculationsDialogOpen] = useState(false);
  const [calculationsData, setCalculationsData] = useState(null);
  const [calculationsLoading, setCalculationsLoading] = useState(false);
  const [calculationsError, setCalculationsError] = useState(null);

  // Close the calculations dialog
  const handleCloseCalculationsDialog = () => {
    setCalculationsDialogOpen(false);
  };

  // Handle calculations request
  const handleCalculateLimits = async () => {
    if (!selectedItemId) return;
    
    // First open the dialog with loading state
    setCalculationsDialogOpen(true);
    setCalculationsData(null);
    setCalculationsLoading(true);
    setCalculationsError(null);
    
    // Then set the global loading state if needed
    if (setLoading) setLoading(true);
    
    try {
      console.log(`Calculating limitations for ${selectedItemId}`);
      
      // Call the API endpoint
      const result = await requirementsApi.calculateLimitations(selectedItemId);
      
      // Update the dialog with the data
      setCalculationsData(result);
    } catch (err) {
      console.error('Calculation error:', err);
      if (setError) setError(`Failed to calculate limitations: ${err.message}`);
      setCalculationsError(err.message || 'Failed to calculate limitations');
    } finally {
      setCalculationsLoading(false);
      if (setLoading) setLoading(false);
    }
  };

  return {
    calculationsDialogOpen,
    calculationsData,
    calculationsLoading,
    calculationsError,
    handleCloseCalculationsDialog,
    handleCalculateLimits
  };
};

export default useCalculations;